import { isEmpty, filter, isInteger } from 'lodash';

import {
  QUESTION_PROMPT_MAX_LENGTH,
  ANSWER_MAX_LENGTH,
} from 'containers/QuestionnairePage/constants';
import { MAX_ALLOWED_STEPS } from './constants';
import { isTickEmpty } from './utils';

function validate({ prompt, slider = {} }) {
  const { minValue, maxValue, rangeStep, ticks = [] } = slider;
  const errors = { tickTooLong: {} };

  if (isEmpty(prompt)) {
    errors.missingPrompt = true;
  }

  const questionTooLong = prompt && prompt.length > QUESTION_PROMPT_MAX_LENGTH;
  if (questionTooLong) {
    errors.questionTooLong = true;
  }

  if (isInteger(minValue) && isInteger(maxValue) && isInteger(rangeStep)) {
    if (minValue >= maxValue) {
      errors.sliderFromLarger = true;
    } else if (!isInteger((maxValue - minValue) / rangeStep)) {
      errors.sliderStepsNotInt = true;
    } else if ((maxValue - minValue) / rangeStep > MAX_ALLOWED_STEPS) {
      errors.sliderStepTooSmall = true;
    } else if (
      Math.ceil((maxValue - minValue) / rangeStep) + 1 <
      ticks.length - 1
    ) {
      errors.sliderTooManyAnswers = true;
    }
  } else {
    errors.sliderMissingValues = true;
  }

  const filteredTicks = ticks.filter((tick) => !tick.isEmptyTick);
  const emptyTicks = filter(filteredTicks, isTickEmpty);
  if (!isEmpty(emptyTicks)) {
    errors.missingTicks = true;
  }

  ticks.forEach((tick) => {
    if (tick.tickLabel.length > ANSWER_MAX_LENGTH) {
      errors.tickTooLong[tick.refId] = true;
    }
  });

  if (isEmpty(errors.tickTooLong)) {
    delete errors.tickTooLong;
  }

  return errors;
}

export default validate;
